import React, { Component } from 'react';
import './App.css';
import Header from './Header.js';
import ContentController from './ContentController.js';
import LoginController from './LoginController.js';

class App extends Component {
    render() {
        return (
              <div className="App">
              <LoginController
                refreshState={() => {
                    this.forceUpdate();
                }}
              />
              <Header/>
              <ContentController/>
              </div>
          );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js